import React from 'react';
import styles from './GameInfoContent.module.scss';
import gameStyles from './GameDetails.module.scss';
import { GameTileProps } from '../modular-grid/types';

export interface GameInfoContentMessages {
  providedBy: string;
  features: string;
}

const GameInfoContent: React.FC<{
  game: GameTileProps;
  staticTexts: GameInfoContentMessages;
}> = ({ game, staticTexts }) => {
  return (
    <div data-testid="game-info-content">
      <div className={styles.topWrapper}>
        <p data-testid="game-info-content-title" className={styles.infoTitle}>
          {staticTexts.providedBy}
        </p>
        <h2
          data-testid="game-info-content-provider"
          className={styles.provider}
        >
          {game.provider}
        </h2>
        {game.features && (
          <>
            <p className={styles.infoTitle}>{staticTexts.features}</p>
            <div
              className={styles.featuresWrapper}
              data-testid="game-info-features"
            >
              {game.features.map((feature: string, index: number) => (
                <div
                  data-testid="game-info-feature"
                  key={index}
                  className={styles.feature}
                >
                  {feature}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <div className={styles.bottomWrapper}>
        <h1 data-testid="game-info-game-title" className={styles.title}>
          {game.title}
        </h1>
        <div
          data-testid="game-info-description"
          className={gameStyles.styles}
          dangerouslySetInnerHTML={{
            __html: game.description,
          }}
        ></div>
      </div>
    </div>
  );
};

export default GameInfoContent;
